// extracted by mini-css-extract-plugin
export default {"changeLink":"vS-z","disabled":"wS-z","inline":"xS-z"};